import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { SentimentPositiveOutlined, Tooltip } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import messageUtil from 'utils/messageUtil'
import SoundbiteSentiment from 'enums/SoundbiteSentiment'
import MetadataIconsContainer from './MetadataIconsContainer'
import { StyledSentimentContainer } from '../index.css'

type SentimentPositiveIconProps = {
  annotated: boolean
}

const SentimentPositiveIcon = ({ annotated }: SentimentPositiveIconProps) => {
  const { t } = useTranslation()
  const theme = useDisplayTheme() as Theme

  const color = sys[theme].semantic.positive.default
  const message = messageUtil.sentimentSingular(SoundbiteSentiment.POSITIVE)
  let tooltip = `${t('sentimentClassification')}: ${message}`
  let annotationMessage = ''
  if (annotated) {
    annotationMessage = `(${t('annotated')})`
    tooltip += ` ${annotationMessage}`
  }

  return (
    <Tooltip mode={theme} enabled content={tooltip}>
      <StyledSentimentContainer>
        <MetadataIconsContainer message={message} annotationMessage={annotationMessage}>
          <SentimentPositiveOutlined color={color} />
        </MetadataIconsContainer>
      </StyledSentimentContainer>
    </Tooltip>
  )
}

export default SentimentPositiveIcon
